'use client'

import { useUserStore } from '@/core/stores/user';
import Link from 'next/link';
import { ReactNode } from 'react';

export default function NavigateButton({ guestChild, singedInChild }: { singedInChild: ReactNode, guestChild: ReactNode }) {
    const { isRegisteredAsInfluencer } = useUserStore()
    return (
        <Link href={isRegisteredAsInfluencer ? '/profile/creator' : '/partnership/sign-in'}>
            {isRegisteredAsInfluencer ? singedInChild : guestChild}

        </Link>
    );
}